import script from "./StatusPill.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusPill.vue?vue&type=script&setup=true&lang=js"

import "./StatusPill.vue?vue&type=style&index=0&id=43192376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43192376"]])

export default __exports__